import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { ToggleFormGroup } from "../toggle-form-group/toggle-form-group";
import styles from "./search-form-header-container.less";

type SearchFormHeaderContainerProps = {
    idPrefix: string;
    showToggle: boolean;
    showFilters: boolean;
    toggleShowFilters: () => void;
};

export const SearchFormHeaderContainer = (props: SearchFormHeaderContainerProps) => {
    const { idPrefix, showToggle, showFilters, toggleShowFilters } = props;

    return (
        <div className={styles.searchFormHeaderContainer}>
            <span className={styles.description}>{resources.common.searchForm.description}</span>
            {showToggle && (
                <ToggleFormGroup
                    checked={showFilters}
                    controlId={`${idPrefix}-search-form-show-filters-toggle`}
                    disabled={false}
                    isRequired={false}
                    label={resources.common.searchForm.showFilters}
                    onChange={toggleShowFilters}
                    value={`${showFilters}`}
                    labelWidth={LabelWidthTypes.EXTRA_SMALL}
                    className={styles.toggleFilters}
                    uncheckedIcon={false}
                    checkedIcon={false}
                />
            )}
        </div>
    );
};